/**
 * Template Customization Schemas
 * Configuration-driven system for per-template customization options.
 */

// ─── Children's Book Illustration Styles ───
export const illustrationStyles = [
  { id: 'watercolor', name: 'Watercolor', desc: 'Soft watercolor with visible brushstrokes', thumbnail: 'https://static.prod-images.emergentagent.com/jobs/6011386d-adfc-4415-9257-23eae86765a4/images/7caecd986d143ae2df62d5d518adbf1b034be3895c257b94f260c4e09b0be086.jpeg' },
  { id: 'storybook', name: 'Storybook Classic', desc: 'Klassisk barnebokillustrasjon, rik og detaljert', thumbnail: 'https://static.prod-images.emergentagent.com/jobs/6011386d-adfc-4415-9257-23eae86765a4/images/10d1a953f85a2c999f4c2b78a24906fc4c3b73e4a92133b2612798cfeca4acec.jpeg' },
  { id: 'scandinavian', name: 'Scandinavian Minimal', desc: 'Rent, geometrisk, begrenset fargepalett', thumbnail: 'https://static.prod-images.emergentagent.com/jobs/6011386d-adfc-4415-9257-23eae86765a4/images/ef7911e7ac9b5ad6e02e00284e5d5a4d468999a5ab295712606af513556dc915.jpeg' },
  { id: 'editorial', name: 'Editorial Luxury', desc: 'Sofistikert, dempede jordtoner, elegant', thumbnail: 'https://static.prod-images.emergentagent.com/jobs/6011386d-adfc-4415-9257-23eae86765a4/images/c6e15d1c913dbc86c5482f12c1fe0d7ad345fc96952f5ef5b625f70cd6853ed8.jpeg' },
  { id: 'soft-pastel', name: 'Soft Pastel', desc: 'Dreamy pastels, soft and sweet', thumbnail: 'https://static.prod-images.emergentagent.com/jobs/6011386d-adfc-4415-9257-23eae86765a4/images/13f7a7c926f5cce6507624f058ccddb1acca822a1e6d25ffb438bbd7c3fd500c.jpeg' },
  { id: 'modern-bold', name: 'Modern Bold', desc: 'Sterke farger, geometriske former, energisk', thumbnail: 'https://static.prod-images.emergentagent.com/jobs/6011386d-adfc-4415-9257-23eae86765a4/images/2a72a743afe4c37c62ae504ec80aef0f7555b76c3fc7c27fdd4f41b9163bc1e6.jpeg' },
  { id: 'vintage', name: 'Vintage', desc: 'Retro nostalgi, eldret papirtekstur, sepia-toner', thumbnail: 'https://static.prod-images.emergentagent.com/jobs/6011386d-adfc-4415-9257-23eae86765a4/images/8e7cb20cbce537fe28d05800fd796f51ff4ba6a801759978a14ed14b44863ca8.jpeg' },
  { id: 'neutral-organic', name: 'Neutral Organic', desc: 'Jordtoner, naturlige teksturer, rolig', thumbnail: 'https://static.prod-images.emergentagent.com/jobs/6011386d-adfc-4415-9257-23eae86765a4/images/0fa344143733830cd30390906e74fbe6dad841d4f1d4d023c21409815736ad49.jpeg' },
];

// ─── Wedding Styles ───
export const weddingStyles = [
  { id: 'romantic-classic', name: 'Romantic Classic', desc: 'Blush, gull, roser og eleganse', thumbnail: 'https://static.prod-images.emergentagent.com/jobs/6011386d-adfc-4415-9257-23eae86765a4/images/bfb64abb075b978d6f0cc024d17266709ea5bbead2ed42f216933adeaee3b26d.jpeg' },
  { id: 'modern-minimal', name: 'Modern Minimal', desc: 'Rent, hvitt, enkel sofistikasjon', thumbnail: 'https://static.prod-images.emergentagent.com/jobs/6011386d-adfc-4415-9257-23eae86765a4/images/4d30026bfaf77f1bd41e5000187fead33736ae649bca8fce56a16ee61397246a.jpeg' },
  { id: 'garden-botanical', name: 'Garden Botanical', desc: 'Green, eucalyptus, natural organic', thumbnail: 'https://static.prod-images.emergentagent.com/jobs/6011386d-adfc-4415-9257-23eae86765a4/images/57c3d83223d267d50d43054a2aa5fb439444d218dcb2eda35c27c6c7a80bd27d.jpeg' },
  { id: 'rustic-vintage', name: 'Rustic Vintage', desc: 'Kraft, villblomster, varme jordtoner', thumbnail: 'https://static.prod-images.emergentagent.com/jobs/6011386d-adfc-4415-9257-23eae86765a4/images/73bda2a95a3a6c703de205560949a516a1c24cddae5a2440937327924277b3c9.jpeg' },
  { id: 'glamorous-luxe', name: 'Glamorous Luxe', desc: 'Darkt, gull, art deco, dramatisk', thumbnail: 'https://static.prod-images.emergentagent.com/jobs/6011386d-adfc-4415-9257-23eae86765a4/images/5776616095689923e7bd3c7858c8ac773e9db2bd5252b577ec2b3b0637e261b4.jpeg' },
  { id: 'coastal', name: 'Coastal', desc: 'Ocean blue, sand, skjell, lett og luftig', thumbnail: 'https://static.prod-images.emergentagent.com/jobs/6011386d-adfc-4415-9257-23eae86765a4/images/a7a7b9180545170f30004a159c0cc854a0da4b7456571be81d1f05cafb715d92.jpeg' },
];

// ─── Color Palettes ───
export const colorPalettes = [
  { id: 'soft-rainbow', name: 'Myk regnbue', colors: ['#F4A7BB', '#F9CB8B', '#F9E98E', '#A8D5BA', '#8EC8E8', '#C4A8D8'] },
  { id: 'ocean-breeze', name: 'Havbris', colors: ['#1A535C', '#4ECDC4', '#F7FFF7', '#FF6B6B', '#FFE66D', '#95E1D3'] },
  { id: 'forest-magic', name: 'Shoesgmagi', colors: ['#2D6A4F', '#40916C', '#52B788', '#95D5B2', '#B7E4C7', '#D8F3DC'] },
  { id: 'sunset-warmth', name: 'Solnedgang', colors: ['#FF6B35', '#F7C59F', '#EFEFD0', '#004E89', '#1A659E', '#FF9F1C'] },
  { id: 'berry-garden', name: 'Berry garden', colors: ['#6B2D5B', '#8B3A62', '#C57B8E', '#E8B4BC', '#F9E4E4', '#4A1942'] },
  { id: 'earthy-neutral', name: 'Earth neutral', colors: ['#8B7355', '#A08C6A', '#C4B08B', '#DED3C0', '#F5F0E8', '#6B5B45'] },
  { id: 'candy-pop', name: 'Candy Pop', colors: ['#FF69B4', '#FF6EB4', '#DDA0DD', '#87CEEB', '#98FB98', '#FFD700'] },
  { id: 'nordic-calm', name: 'Nordisk ro', colors: ['#D4C5A9', '#E8DCC8', '#F5F1EB', '#8FA5A0', '#6B7F7A', '#3D4F4B'] },
];

// ─── Wedding-specific palettes ───
export const weddingPalettes = [
  { id: 'blush-gold', name: 'Blush & Gold', colors: ['#F4C2C2', '#FFD700', '#FFFFFF', '#F5E6CC', '#DFC5A5', '#8B7355'] },
  { id: 'sage-ivory', name: 'Sage & Ivory', colors: ['#9CAF88', '#C1CFA1', '#FFFFF0', '#E8E0D0', '#D4C5A9', '#6B7F6B'] },
  { id: 'dusty-blue', name: 'Dusty Blue', colors: ['#6B8E9B', '#A8C4D4', '#D4E4EC', '#F0F0F0', '#C4A882', '#8B7355'] },
  { id: 'burgundy-navy', name: 'Burgundy & Navy', colors: ['#722F37', '#1B2A4A', '#C4A882', '#F5F0E8', '#8B6F47', '#2D2D2D'] },
  { id: 'terracotta', name: 'Terracotta', colors: ['#C06014', '#D4956A', '#E8C8A0', '#F5F0E8', '#6B5B45', '#3D4F4B'] },
  { id: 'lavender-cream', name: 'Lavender & Cream', colors: ['#9B8EC4', '#C8BFE7', '#F0E6FF', '#FFFFF0', '#E8DCC8', '#8B7A8B'] },
  { id: 'emerald-gold', name: 'Smaragd & Gold', colors: ['#046307', '#2E8B57', '#FFD700', '#F5F0E8', '#C4A882', '#1A1A1A'] },
  { id: 'peach-cream', name: 'Fersken & Cream', colors: ['#FFDAB9', '#FFB07C', '#FFFFF0', '#FFF8DC', '#E8DCC8', '#8B7355'] },
];

// ─── Character Fields (for children's book) ───
export const characterFields = {
  basic: [
    { id: 'name', type: 'text', label: 'Navn', required: true, placeholder: 'Childets or karakterens navn' },
    { id: 'role', type: 'select', label: 'Role', required: true, options: [
      { value: 'main', label: 'Hovedperson' }, { value: 'supporting', label: 'Birolle' },
      { value: 'parent', label: 'Forelder' }, { value: 'sibling', label: 'Sibling' },
      { value: 'friend', label: 'Venn' }, { value: 'pet', label: 'Pets' }, { value: 'other', label: 'Annen' },
    ]},
    { id: 'age', type: 'number', label: 'Alder', placeholder: '5', min: 0, max: 99 },
    { id: 'gender', type: 'select', label: 'Gender / pronouns', options: [
      { value: 'girl', label: 'Jente (hun/henne)' }, { value: 'boy', label: 'Gutt (han/ham)' },
      { value: 'nonbinary', label: 'Non-binary (they)' }, { value: 'other', label: 'Other' },
    ]},
  ],
  appearance: [
    { id: 'hairColor', type: 'color-select', label: 'Hairfarge', options: [
      { value: 'blonde', label: 'Blond', color: '#F5DEB3' }, { value: 'brown', label: 'Brun', color: '#8B6914' },
      { value: 'dark-brown', label: 'Darkebrun', color: '#3B2F2F' }, { value: 'black', label: 'Svart', color: '#1C1C1C' },
      { value: 'red', label: 'Red', color: '#B7410E' }, { value: 'auburn', label: 'Auburn', color: '#922724' },
      { value: 'gray', label: 'Gray', color: '#A0A0A0' }, { value: 'white', label: 'White', color: '#F0F0F0' },
    ]},
    { id: 'hairStyle', type: 'select', label: 'Hairstil', options: [
      { value: 'short-straight', label: 'Kort og rett' }, { value: 'short-curly', label: 'Short and curly' },
      { value: 'medium-straight', label: 'Mellomlangt og rett' }, { value: 'medium-wavy', label: 'Medium length and wavy' },
      { value: 'long-straight', label: 'Langt og rett' }, { value: 'long-curly', label: 'Long and curly' },
      { value: 'braids', label: 'Fletter' }, { value: 'afro', label: 'Afro' }, { value: 'ponytail', label: 'Hestehale' },
      { value: 'bun', label: 'Knute' }, { value: 'buzz', label: 'Kort klipp' }, { value: 'bald', label: 'No hair' },
    ]},
    { id: 'eyeColor', type: 'color-select', label: 'Eye color', options: [
      { value: 'brown', label: 'Brun', color: '#8B4513' }, { value: 'blue', label: 'Blue', color: '#4169E1' },
      { value: 'green', label: 'Green', color: '#228B22' }, { value: 'hazel', label: 'Nut brown', color: '#8E7618' },
      { value: 'gray', label: 'Gray', color: '#808080' }, { value: 'dark', label: 'Dark', color: '#2F1B14' },
    ]},
    { id: 'skinTone', type: 'color-select', label: 'Hudtone', options: [
      { value: 'very-light', label: 'Veldig lys', color: '#FFE0BD' }, { value: 'light', label: 'Light', color: '#F1C27D' },
      { value: 'medium-light', label: 'Middels lys', color: '#E0A66E' }, { value: 'medium', label: 'Middels', color: '#C68642' },
      { value: 'medium-dark', label: 'Medium dark', color: '#8D5524' }, { value: 'dark', label: 'Dark', color: '#5C3317' },
    ]},
    { id: 'clothing', type: 'text', label: 'Clothing / stil', placeholder: 'e.g. red dress with flowers' },
    { id: 'personality', type: 'text', label: 'Personlighet', placeholder: 'e.g. nysgjerrig, modig, snill' },
  ],
  inclusive: [
    { id: 'freckles', type: 'toggle-detail', label: 'Fregner', detailLabel: 'Placement', detailPlaceholder: 'e.g. over nesen' },
    { id: 'birthmark', type: 'toggle-detail', label: 'Birthmark', detailLabel: 'Placement', detailPlaceholder: 'e.g. venstre kinn' },
    { id: 'glasses', type: 'toggle-select', label: 'Briller', options: [
      { value: 'round', label: 'Runde' }, { value: 'rectangular', label: 'Rectangular' }, { value: 'cat-eye', label: 'Cat eye' },
    ]},
    { id: 'hearingAid', type: 'toggle', label: 'Hearing aid' },
    { id: 'cochlearImplant', type: 'toggle', label: 'Cochleaimplantat' },
    { id: 'braces', type: 'toggle', label: 'Tannregulering' },
    { id: 'wheelchair', type: 'toggle-select', label: 'Rullestol', options: [
      { value: 'standard', label: 'Standard' }, { value: 'sport', label: 'Sport' }, { value: 'electric', label: 'Elektrisk' },
    ]},
    { id: 'crutches', type: 'toggle', label: 'Krykker' },
    { id: 'prosthetic', type: 'toggle-detail', label: 'Protese', detailLabel: 'Kroppsdel', detailPlaceholder: 'e.g. venstre arm' },
    { id: 'otherFeatures', type: 'textarea', label: 'Andre kjennetegn', placeholder: 'Beskriv andre kjennetegn' },
  ],
};

export const defaultCharacter = {
  name: '', role: 'main', age: '', gender: 'girl',
  hairColor: 'brown', hairStyle: 'medium-wavy', eyeColor: 'brown',
  skinTone: 'medium-light', clothing: '', personality: '',
  referenceImage: null, inclusiveFeatures: {},
};

// ─── Budget Categories (for wedding) ───
export const weddingBudgetCategories = [
  { id: 'venue', name: 'Venue / Venue', icon: 'MapPin' },
  { id: 'catering', name: 'Catering & Mat', icon: 'UtensilsCrossed' },
  { id: 'drinks', name: 'Drikke & Alkohol', icon: 'Wine' },
  { id: 'cake', name: 'Kake & Dessert', icon: 'Cake' },
  { id: 'flowers', name: 'Flowers', icon: 'Flower' },
  { id: 'decor', name: 'Dekor & Utleie', icon: 'Lamp' },
  { id: 'photo', name: 'Fotograf', icon: 'Camera' },
  { id: 'video', name: 'Videograf', icon: 'Video' },
  { id: 'music', name: 'DJ / Band / Musikere', icon: 'Music' },
  { id: 'dress', name: 'Wedding dress', icon: 'Shirt' },
  { id: 'suit', name: 'Dress / Partners antrekk', icon: 'Shirt' },
  { id: 'beauty', name: 'Hair, Makeup & Beauty', icon: 'Sparkles' },
  { id: 'rings', name: 'Ringer & Jewelry', icon: 'Gem' },
  { id: 'stationery', name: 'Invitations & Stationery', icon: 'Mail' },
  { id: 'transport', name: 'Transport', icon: 'Car' },
  { id: 'hotel', name: 'Hotell / Accommodation', icon: 'Building' },
  { id: 'childcare', name: 'Childeaktiviteter & Childevakt', icon: 'Baby' },
  { id: 'entertainment', name: 'Underholdning', icon: 'PartyPopper' },
  { id: 'favors', name: 'Gaver / Favors', icon: 'Gift' },
  { id: 'honeymoon', name: 'Honeymoon', icon: 'Plane' },
  { id: 'misc', name: 'Miscellaneous', icon: 'MoreHorizontal' },
  { id: 'buffer', name: 'Uforutsette utgifter (buffer)', icon: 'ShieldAlert' },
];

// ─── Memorial Tribute Options ───
export const memorialTributes = [
  { id: 'reserved-seat', label: 'Reservert stol under seremonien' },
  { id: 'photo-on-seat', label: 'Photo on a reserved chair' },
  { id: 'flower-on-seat', label: 'Flower/bouquet on the chair' },
  { id: 'memory-table', label: 'Eget minnetable med bilder' },
  { id: 'candle', label: 'Tent lys' },
  { id: 'memorial-sign', label: 'Minneramme or signs' },
  { id: 'program-text', label: 'Navn or tekst i weddingprogrammet' },
  { id: 'bouquet-flower', label: 'Spesiell blomst i brudebuketten' },
  { id: 'bouquet-locket', label: 'Medallion/photo on the bouquet' },
  { id: 'heirloom', label: 'Smykke or arvestykke' },
  { id: 'dedicated-song', label: 'Dedikert sang' },
  { id: 'toast', label: 'Toast or mention in speech' },
  { id: 'moment-of-silence', label: 'A quiet moment during the ceremony' },
  { id: 'donation', label: 'Donasjon til en sak personen brydde seg om' },
  { id: 'favorite-dessert', label: 'Servere personens favorittdessert/drikke' },
  { id: 'personal-item', label: 'Bruke noe personen eide' },
  { id: 'custom', label: 'Egendefinert idé' },
];

// ─── Children's Book Schema ───
const childrenBookSchema = {
  id: 'memory-book',
  name: 'Childebok / Minnebok',
  styleOptions: illustrationStyles,
  paletteOptions: colorPalettes,
  quickFields: ['title', 'childName', 'childAge', 'theme', 'illustrationStyle'],
  sections: [
    { id: 'content', title: 'Innhold', icon: 'BookOpen', fields: [
      { id: 'title', type: 'text', label: 'Boktittel', required: true, placeholder: 'e.g. «Lilys store eventyr»' },
      { id: 'theme', type: 'select', label: 'Tema', required: true, options: [
        { value: 'adventure', label: 'Eventyr' }, { value: 'friendship', label: 'Vennskap' },
        { value: 'courage', label: 'Mot og selvtillit' }, { value: 'nature', label: 'Natur og dyr' },
        { value: 'family', label: 'Familie' }, { value: 'bedtime', label: 'Leggetid' },
        { value: 'birthday', label: 'Bursdag' }, { value: 'first-day', label: 'First dag (barnehage/skole)' },
        { value: 'new-sibling', label: 'New sibling' }, { value: 'custom', label: 'Egendefinert' },
      ]},
      { id: 'customTheme', type: 'text', label: 'Beskriv temaet', conditional: { field: 'theme', value: 'custom' }, placeholder: 'Beskriv temaet' },
      { id: 'message', type: 'textarea', label: 'Budskap / moral (optional)', placeholder: 'What do you want the child to learn?' },
      { id: 'ageRange', type: 'select', label: 'Aldersgruppe', options: [
        { value: '0-2', label: '0–2 years' }, { value: '3-5', label: '3–5 years' },
        { value: '6-8', label: '6–8 years' }, { value: '9-12', label: '9–12 years' },
      ]},
      { id: 'pageCount', type: 'select', label: 'Antall sider', options: [
        { value: '8', label: '8 sider' }, { value: '12', label: '12 sider' },
        { value: '16', label: '16 sider' }, { value: '24', label: '24 sider' }, { value: '32', label: '32 sider' },
      ]},
      { id: 'language', type: 'select', label: 'Language', options: [
        { value: 'no', label: 'Norsk' }, { value: 'en', label: 'English' },
        { value: 'sv', label: 'Svenska' }, { value: 'da', label: 'Dansk' },
      ]},
    ]},
    { id: 'characters', title: 'Karakterer', icon: 'Users', type: 'character-builder', config: { minCharacters: 1, maxCharacters: 8 } },
    { id: 'style', title: 'Stil', icon: 'Palette', type: 'style-picker' },
    { id: 'colors', title: 'Farger', icon: 'Paintbrush', type: 'color-palette-picker' },
  ],
};

// ─── Wedding Planner Schema ───
const weddingPlannerSchema = {
  id: 'wedding-planner',
  name: 'Bryllupsplanner',
  styleOptions: weddingStyles,
  paletteOptions: weddingPalettes,
  quickFields: ['person1Name', 'person2Name', 'weddingDate', 'guestCount', 'venueType', 'totalBudget', 'bookTheme'],
  sections: [
    { id: 'couple', title: 'Paret', icon: 'Heart', type: 'couple-setup' },
    { id: 'design', title: 'Choose design', icon: 'Palette', type: 'book-design-selector' },
    {
      id: 'basics', title: 'Bryllupet', icon: 'BookOpen',
      fields: [
        { id: 'weddingDate', type: 'date', label: 'Wedding date', required: true },
        { id: 'weddingTime', type: 'text', label: 'Klokkeslett for seremonien', placeholder: 'e.g. 14:00' },
        { id: 'venueName', type: 'text', label: 'Sted / Venue', placeholder: 'Venue name' },
        { id: 'venueAddress', type: 'text', label: 'Adresse', placeholder: 'Adressen til lokalet' },
        { id: 'ceremonyType', type: 'select', label: 'Type vielse', options: [
          { value: 'church', label: 'Kirke' }, { value: 'civil', label: 'Civil' },
          { value: 'outdoor', label: 'Outdoor' }, { value: 'destination', label: 'Destination wedding' },
          { value: 'other', label: 'Other' },
        ]},
        { id: 'venueType', type: 'select', label: 'Inne or ute?', required: true, options: [
          { value: 'indoor', label: 'Indoor' }, { value: 'outdoor', label: 'Outdoor' },
          { value: 'mixed', label: 'Mixed' },
        ]},
        { id: 'formality', type: 'select', label: 'Dresscode / formalitet', options: [
          { value: 'formal', label: 'Formelt' }, { value: 'semiformal', label: 'Semi-formelt' },
          { value: 'casual', label: 'Uformelt' }, { value: 'themed', label: 'Tema' },
        ]},
        { id: 'guestCount', type: 'number', label: 'Number of guests (estimert)', required: true, placeholder: '80' },
        { id: 'mood', type: 'multi-select', label: 'Desired mood (choose 1–3)', maxSelections: 3, options: [
          { value: 'romantic', label: 'Romantisk' }, { value: 'relaxed', label: 'Avslappet' },
          { value: 'elegant', label: 'Elegant' }, { value: 'festive', label: 'Festlig' },
          { value: 'intimate', label: 'Intim' }, { value: 'grand', label: 'Grand' },
          { value: 'bohemian', label: 'Boho' }, { value: 'modern', label: 'Moderne' },
        ]},
        { id: 'priorities', type: 'multi-select', label: 'Top 3 prioriteringer', maxSelections: 3, options: [
          { value: 'food', label: 'Mat' }, { value: 'party', label: 'Fest' },
          { value: 'photos', label: 'Bilder' }, { value: 'flowers', label: 'Flowers' },
          { value: 'guest-experience', label: 'Guesteopplevelse' }, { value: 'budget', label: 'Budget' },
          { value: 'decor', label: 'Dekor' }, { value: 'music', label: 'Music' },
        ]},
        { id: 'hasAlcohol', type: 'select', label: 'Alkoholservering?', options: [
          { value: 'yes', label: 'Ja' }, { value: 'limited', label: 'Begrenset' }, { value: 'no', label: 'Nei' },
        ]},
      ],
    },
    { id: 'guests', title: 'Guests', icon: 'Users', type: 'guest-list' },
    { id: 'seating', title: 'Seating chart', icon: 'LayoutGrid', type: 'seating-chart' },
    { id: 'moodboard', title: 'Moodboard', icon: 'Palette', type: 'moodboard' },
    { id: 'flowers', title: 'Flowers', icon: 'Heart', type: 'flower-planner' },
    { id: 'stationery', title: 'Brevpapir & Skilt', icon: 'BookOpen', type: 'stationery-planner' },
    { id: 'attire', title: 'Attire & Beauty', icon: 'Sparkles', type: 'attire-planner' },
    { id: 'photos', title: 'Fotoliste', icon: 'Eye', type: 'photo-checklist' },
    { id: 'food', title: 'Mat & Drikke', icon: 'UtensilsCrossed', type: 'food-planner' },
    { id: 'budget', title: 'Budget', icon: 'Calculator', type: 'budget-tracker' },
    { id: 'music', title: 'Music & Fest', icon: 'Music', type: 'music-planner' },
    { id: 'vendors', title: 'Vendors', icon: 'Briefcase', type: 'vendor-list' },
    { id: 'timeline', title: 'Timeline', icon: 'Clock', type: 'wedding-timeline' },
    { id: 'ceremony-detail', title: 'Ceremony', icon: 'Heart', type: 'ceremony-planner' },
    { id: 'kids', title: 'Children at the wedding', icon: 'Baby', type: 'kids-planner', conditional: { field: '_hasChildren', value: true } },
    { id: 'transport', title: 'Transport & Accommodation', icon: 'Car', type: 'transport-planner' },
    { id: 'responsibilities', title: 'Responsibility tracker', icon: 'ClipboardList', type: 'responsibility-tracker' },
    { id: 'emergency', title: 'Emergency Kit', icon: 'ShieldCheck', type: 'emergency-kit' },
    { id: 'day-before', title: 'Day before', icon: 'Calendar', type: 'day-before-planner' },
    { id: 'wedding-morning', title: 'Wedding morningen', icon: 'Sun', type: 'wedding-morning-planner' },
    { id: 'after-party', title: 'Etter festen', icon: 'Package', type: 'after-party-planner' },
    { id: 'honeymoon', title: 'Honeymoon', icon: 'Plane', type: 'honeymoon-planner' },
    { id: 'legal', title: 'Legal & Admin', icon: 'FileText', type: 'legal-admin-planner' },
    { id: 'pets', title: 'Pets', icon: 'Heart', type: 'pet-planner', optional: true },
    { id: 'memorial', title: 'Those we carry with us', icon: 'Heart', type: 'memorial', optional: true },
    { id: 'planb', title: 'Plan B / Weather', icon: 'CloudRain', type: 'plan-b', conditional: { field: 'venueType', values: ['outdoor', 'mixed'] } },
  ],
};

// ─── Schema Registry ───
const schemas = {
  'memory-book': childrenBookSchema,
  'wedding-planner': weddingPlannerSchema,
};

export function getCustomizationSchema(productTypeId) { return schemas[productTypeId] || null; }
export function hasCustomization(productTypeId) { return !!schemas[productTypeId]; }
